var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{class:_vm.$style.root},[_c('base-icon',{class:_vm.$style.icon,attrs:{"type":"timer"}}),_vm._v(" "),_c('span',{class:_vm.$style.title,domProps:{"innerHTML":_vm._s(_vm.title)}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }